<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 72 72"
    :color="color"
    title="Logo Youtube"
  >
    <!-- eslint-disable max-len -->
    <path
      d="M42.0112 35.3737L33.5887 31.4437C32.8538 31.1025 32.25 31.485 32.25 32.2987V39.7013C32.25 40.515 32.8538 40.8975 33.5887 40.5562L42.0075 36.6262C42.7463 36.2812 42.7462 35.7188 42.0112 35.3737ZM36 0C16.1175 0 0 16.1175 0 36C0 55.8825 16.1175 72 36 72C55.8825 72 72 55.8825 72 36C72 16.1175 55.8825 0 36 0ZM36 50.625C17.5725 50.625 17.25 48.9637 17.25 36C17.25 23.0362 17.5725 21.375 36 21.375C54.4275 21.375 54.75 23.0362 54.75 36C54.75 48.9637 54.4275 50.625 36 50.625Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
